import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Components/Footer/Footer';
import Navbar from '../../Components/Navbar/Navbar';

const Blog = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="flex flex-col justify-center items-center h-[85vh]">
        <h2 className="text-xl text-white font-bold ">Cooming soon.......</h2>
        <div className="mt-10">
          <button
            onClick={() => navigate('/')}
            className="p-3 border-2 border-primary rounded text-secondary text-white"
          >
            Back To Home
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
